import React from 'react'
import { CircularProgress } from '@material-ui/core'
import { useUsersCount } from '../../hooks/useUsersCount'
import { useEventById } from '../../hooks/use-event-by-id'

export function ChatAudienceCounter() {
  const { data: event } = useEventById()
  const { usersCount, status } = useUsersCount({
    refetchInterval: 10000,
    eventId: event?.eventId,
    enabled: !!event?.eventId,
  })

  if (status === 'loading') {
    return <CircularProgress size="1.5rem" style={{ marginLeft: '0.5rem' }} />
  }

  if (status === 'error') {
    return <span>&#40;&#45;&#41;</span>
  }

  return <span>&#40;{usersCount}&#41;</span>
}
